module.exports = __webpack_public_path__ + "static/media/universal-app-montage.ae594e45.webp";